import loadable from '@loadable/component';

export const OrgDashboardBuyCreditsLinksPageLoadable = loadable(
  () => import('./OrgDashboardBuyCreditsLinksPage'),
  { resolveComponent: (module) => module.OrgDashboardBuyCreditsLinksPage },
);
